// createed by feifei.ji
import Sticky from "./sticky.js";
export default Vue => {
  Vue.directive("loadmore", {
    bind(el, binding) {
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM = el.querySelector(
        ".el-select-dropdown .el-select-dropdown__wrap"
      );
      SELECTWRAP_DOM.addEventListener("scroll", function () {
        const CONDITION =
          this.scrollHeight - this.scrollTop <= this.clientHeight + 6;

        if (CONDITION) {
          binding.value();
        }
      });
    }
  });
  Vue.directive("money", {
    // 金额要求不能输入负数，只能输入数字和小数点
    // TODO: 区分正整数和带小数的金额
    inserted: el => {
      el.addEventListener("keypress", e => {
        e = e || window.event;
        let charcode = typeof e.charCode == "number" ? e.charCode : e.keyCode;
        let re = /\d/;
        if (charcode == 46) {
          if (String(el.value).includes(".")) {
            e.preventDefault();
          }
          return;
        } else if (
          !re.test(String.fromCharCode(charcode)) &&
          charcode > 9 &&
          !e.ctrlKey
        ) {
          if (e.preventDefault) {
            e.preventDefault();
          } else {
            e.returnValue = false;
          }
        }
      });
    }
  });
  Vue.directive("Sticky", Sticky);
};
